import { Component, Input } from '@angular/core';

export type KpiIconVariant = 'danger' | 'warning' | 'amber' | 'success';
export type KpiValueTone = 'default' | 'success';
export type KpiSubtitleTone = 'muted' | 'danger';

@Component({
  selector: 'app-dashboard-card',
  standalone: false,
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent {
  @Input() title = '';
  @Input() value: string | number = '';
  @Input() subtitle = '';
  @Input() icon = '';
  @Input() iconVariant: KpiIconVariant = 'danger';
  @Input() valueTone: KpiValueTone = 'default';
  @Input() subtitleTone: KpiSubtitleTone = 'muted';
  /** Quando `true`, aplica visual de destaque (card "hero" da grid). */
  @Input() destaque = false;
}
